import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'
import api from 'api'
import moment from 'moment'

const FETCH_REQUEST = 'realhub/customDeadline/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/customDeadline/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/customDeadline/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/customDeadline/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/customDeadline/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/customDeadline/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/customDeadline/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/customDeadline/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/customDeadline/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  creating: false,
  deleting: [],
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
    loading: true,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(id){
  return {
    type: DELETE_REQUEST,
    payload: id,
  }
}

export function deleteSuccess(id){
  return {
    type: DELETE_SUCCESS,
    payload: id,
  }
}

export function deleteFailure(id, errors = []){
  return {
    type: FETCH_FAILURE,
    payload: id,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadCustomDeadlines(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    // Encode Params
    const promise = api('/admin/custom_deadlines.json', options)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CUSTOM_DEADLINE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        return dispatch(fetchSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

const getOptions = (options) => {
  const { occurs_daily, enabled_days } = options
  const sendedOptions = {
    ...options,
    deadline_time: options.deadline_time.format('HH:mm'),
  }

  if (occurs_daily && enabled_days && enabled_days.length){
    delete sendedOptions.enabled_days
  }


  return sendedOptions
}

export function createCustomDeadline(customDeadline, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      custom_deadline: getOptions(customDeadline),
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/custom_deadlines.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CUSTOM_DEADLINE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteCustomDeadline(id, options){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest(id))

    const promise = api(`/admin/custom_deadlines/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CUSTOM_DEADLINE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess(id))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(id))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload, result, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: [...state.deleting, payload],
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: state.deleting.filter(id => id !== payload),
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: state.deleting.filter(id => id !== payload),
        errors,
      })
    default:
      return state
  }
}
